module.exports = __webpack_public_path__ + "img/logo.48e2ea0a.jpg";